 var hasFocusLink = function(scope, elem, attrs){

  //modelObject is a scope property of the parent/current scope
  const wFocus = scope.$watch(attrs.hasFocus, (value)=>{
    if(scope.$eval(attrs.hasFocus)) {
      elem[0].focus();
    }
  });

  scope.$on('$destroy', () => { wFocus() });
 }
 export default function () {
    return {
      restrict: 'A',
      link: hasFocusLink
    };
  }
